export default "__VITE_ASSET__234aec73__"